// Grab the current page url path
const path = window.location.pathname;
DomObserver.observe('a', links => {
  links.forEach(link => {
    // Start by grabbing the href value from the link
    const href = link.getAttribute('href');
    // Convert the href to a URL
    const url = new URL(href, window.location.origin);
    // Convert the pathname to a string
    const linkpath = url.pathname.toString();

    // Remove section and current classes from all links
    link.classList.remove('section', 'current', 'linking-mode');

    // If the url origin does not match the current origin, return
    if (url.origin != window.location.origin) return;

    // If the current path is /xxx/yyy and the linkpath is /xxx/yyy, add the class 'current'
    // If the current path is /xxx/yyy/zzz and the linkpath is /xxx/yyy, add the class 'section'
    if (path === linkpath) return link.classList.add('current', 'linking-mode');
    if (path.startsWith(linkpath) && linkpath !== "/" && path.charAt(linkpath.length) === '/') {
      return link.classList.add('section', 'linking-mode');
    }
  });
});